<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="election-headcount">
  <div class="p-30" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Effectif pris en compte</p>
        <p class="no-margin dark-gray text-sm">Données pour le calcul des seuils et la répartition des sièges</p>
      </div>
    </div>
  </div>

  <div class="p-30">
    <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px;">
      <div>
        <p class="dark-blue no-margin">Effectif total <span class="red">*</span></p>
        <input [(ngModel)]="headcount.total" (wheel)="$event.preventDefault()" (ngModelChange)="calculateFullMembers()" type="number" min="0" name="total"
          id="total" class="w-full text-md dark-blue pap-input" value="{{headcount.total}}">
      </div>

      <div style="position: relative;">
        <div class="flex align-items-center gap-5">
          <p class="dark-blue no-margin">Nombre de titulaires <span class="red">*</span></p>
          <span class="pointer tooltip-trigger" (click)="toggleTooltip()"
            style="color: #1990FF; font-size: 16px; cursor: pointer;">ⓘ</span>
        </div>
        <div *ngIf="showTooltip" class="tooltip-container"
          style="position: absolute; top: 30px; left: 0; z-index: 1000; background: white; border: 1px solid #E2E8F0; border-radius: 8px; padding: 15px; box-shadow: 0 4px 6px rgba(0,0,0,0.1); min-width: 300px; max-height: 400px; overflow-y: auto;">
          <div class="flex content-between align-items-center mb-10">
            <p class="dark-blue bold no-margin">Barème légal</p>
            <span class="pointer" (click)="toggleTooltip()"
              style="color: #94A3B8; font-size: 18px; cursor: pointer;">✕</span>
          </div>
          <table style="width: 100%; border-collapse: collapse;">
            <thead>
              <tr style="background: #F0F5FF;">
                <th style="padding: 8px; text-align: left; border-bottom: 1px solid #E2E8F0;" class="dark-blue text-sm">
                  Effectif</th>
                <th style="padding: 8px; text-align: center; border-bottom: 1px solid #E2E8F0;"
                  class="dark-blue text-sm">Titulaires</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let range of fullMembersRanges; let i = index"
                [style.background]="i % 2 === 0 ? '#FAFBFC' : 'white'">
                <td style="padding: 6px 8px; border-bottom: 1px solid #F0F5FF;" class="dark-gray text-xs">
                  {{range.min}} - {{range.max === Infinity ? '+' : range.max}}
                </td>
                <td style="padding: 6px 8px; text-align: center; border-bottom: 1px solid #F0F5FF;"
                  class="dark-blue text-xs bold">
                  {{range.members}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <input [(ngModel)]="headcount.fullMembers" (wheel)="$event.preventDefault()"
          (ngModelChange)="onHeadcountChange()" type="number" min="0" name="fullMembers" id="fullMembers"
          class="w-full text-md dark-blue pap-input" value="{{headcount.fullMembers}}" [disabled]="suggestionChecked">
        <div class="flex align-items-center gap-10">
          <input type="checkbox" name="suggestion" id="suggestion" [(ngModel)]="suggestionChecked"
            (ngModelChange)="onSuggestionChange()" class="pointer">
          <p class="dark-gray text-xs">
            Utiliser la valeur suggérée / Suggestion : <span class="bold">{{suggestedValue}}</span>
          </p>
        </div>
      </div>

      <div>
        <p class="dark-blue no-margin">Nombre de collèges <span class="red">*</span></p>
        <input [(ngModel)]="headcount.numberOfColleges" (wheel)="$event.preventDefault()"
          (ngModelChange)="onNumberOfCollegesChange()" type="number" name="numberOfColleges" id="numberOfColleges"
          class="w-full text-md dark-blue pap-input" value="{{headcount.numberOfColleges}}" min="1" max="4">
      </div>
    </div>
  </div>
</div>